import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const customerReviewRoutes = {
  name: 'customer-review',
  path: 'customer-review',
  component: () => import('./CustomerReview.vue'),
  // `kiosk` (TASK-207): màn đặt trước khách. KHÔNG thêm `fullscreen` — màn tự gọi `useFullscreen()`,
  // thêm meta đó là hai nơi cùng đăng ký listener `fullscreenchange` (xem `router/route-meta.d.ts`).
  meta: { i18n, kiosk: true },
} satisfies RouteRecordRaw;
